<template>
    <main id="main" role="main">
        <div id="logoContainer"></div>
        <div id="menu">
            <nav>
                <router-link id="home" :class="selectedStates[0] == 1 ? 'anchor selected' : 'anchor'" to="/home" v-on:click.native="setSelected(0)">Home</router-link>
                <a class="ph">/</a>
                <router-link id="leistungen" :class="selectedStates[1] == 1 ? 'anchor selected' : 'anchor'" to="/leistungen" v-on:click.native="setSelected(1)">Leistungen</router-link>
                <a class="ph">/</a>
                <router-link id="team" :class="selectedStates[2] == 1 ? 'anchor selected' : 'anchor'" to="/team" v-on:click.native="setSelected(2)">Team</router-link>
                <a class="ph">/</a>
                <router-link id="anfahrt" :class="selectedStates[3] == 1 ? 'anchor selected' : 'anchor'" to="/anfahrt" v-on:click.native="setSelected(3)">Anfahrt</router-link>
                <a class="ph">/</a>
                <router-link id="bilder" :class="selectedStates[4] == 1 ? 'anchor selected' : 'anchor'" to="/bilder" v-on:click.native="setSelected(4)">Bilder</router-link>
            </nav>
        </div>
        <router-view/>
        <div class="footer">
          <a>Salon Rosemarie</a>
          <a class="ph">/</a>
          <a>Sportstraße 30</a>
          <a class="ph">/</a>
          <a class="lineBreaker"></a>
          <a>4551 Ried im Traunkreis</a>
          <a class="ph">/</a>
          <a>Telefon: 07588 6262</a>
        </div>
    </main>
</template>

<script>
export default {
  name: 'app',

  data () {
    return {
      selectedStates: [0,0,0,0,0]
    }
  },
  methods: {
    setSelected(anchor){
      this.selectedStates = [0,0,0,0,0]
      this.selectedStates[anchor] = 1;
    }
  }
}
</script>

<style lang="scss">
@import './scss/styles.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue